import { CreateActionParams } from '../actions';

export type OnAddonSelect = (
  addonId: string,
  isSelected: boolean,
  serviceSlotId: string,
) => void;

export function createOnAddonSelectAction({
  getControllerState,
  internalActions: { calculatePaymentDetails, updateServiceSlot },
}: CreateActionParams): OnAddonSelect {
  return async (
    addonId: string,
    isSelected: boolean,
    serviceSlotId: string,
  ) => {
    const [state] = getControllerState();
    const { serviceData } = state;
    const slotService = serviceData.slotServices[serviceSlotId];
    const group = slotService.addOnByGroup?.find((g) =>
      g.addOns?.some((a) => a.id === addonId),
    );

    if (!group) {
      return;
    }

    const addon = group.addOns?.find((a) => a.id === addonId);
    if (!addon) {
      return;
    }

    const currentSelectedAddons = slotService.selectedAddons || {};
    let newSelectedAddons: typeof currentSelectedAddons;

    if (isSelected) {
      // Check if we can add more addons based on the group's limit
      if (
        group.maxNumberOfAddOns &&
        Object.keys(currentSelectedAddons).length >= group.maxNumberOfAddOns
      ) {
        return;
      }
      newSelectedAddons = {
        ...currentSelectedAddons,
        [addonId]: {
          id: addon.id!,
          quantity: 1,
          groupId: group.id!,
          price: addon.price,
          currency: addon.currency,
        },
      };
    } else {
      const { [addonId]: _, ...rest } = currentSelectedAddons;
      newSelectedAddons = rest;
    }

    updateServiceSlot(
      {
        selectedAddons: newSelectedAddons,
      },
      serviceSlotId,
    );

    await calculatePaymentDetails({});
  };
}
